import {createMandatoryContext} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {EditorAccess, EditorAccessModesEnum} from './editorModel';

/*
 * Types.
 */

export interface BaseEditorContext {
  namespace: string;
  isEditing: boolean;
  isReadOnly: boolean;
  access: EditorAccess;

  // Feature flags.
  hasExpressions: boolean;
  hasHighlightErrorsFlag: boolean;
}

export interface CreateBaseEditorContextProps {
  namespace: string;
  isEditing?: boolean;
  isReadOnly?: boolean;

  // Feature flags.
  hasExpressions: boolean;
  hasHighlightErrorsFlag: boolean;
}

/*
 * Context.
 */

export const [BaseEditorContext, useBaseEditorContext] = createMandatoryContext<BaseEditorContext>();

export const createBaseEditorContext = ({
  namespace,
  isEditing,
  isReadOnly,
  hasExpressions,
  hasHighlightErrorsFlag,
}: CreateBaseEditorContextProps): BaseEditorContext => {
  const access = {
    mode: isReadOnly ? EditorAccessModesEnum.READ : EditorAccessModesEnum.WRITE,
  };

  return {
    namespace,
    isEditing: Boolean(isEditing),
    isReadOnly: Boolean(isReadOnly),
    access,
    hasExpressions,
    hasHighlightErrorsFlag,
  };
};
